import { TWAction } from '@libs/types';

/** `uiEffects.transition.direction` — which way the page change plays. */
export enum UiTransitionDirection {
    forward = 'forward',
    back = 'back',
}

/** `uiEffects.transition.orientation` — the axis the pages slide along. */
export enum UiTransitionOrientation {
    horizontal = 'horizontal',
    vertical = 'vertical',
}

/** Page-change animation as the backend sends it; values are not trusted (unknown strings may arrive). */
export type TUiTransition = {
    direction?: UiTransitionDirection | string;
    orientation?: UiTransitionOrientation | string;
};

/**
 * Screen transition animations (backend contract). Set on a page — the default for every navigation leaving it —
 * and on an action, which overrides the page for that action only. Not declared in `@libs/types`: only consumer
 * reads it, from the page fields and the action the core page-change hook hands over.
 */
export type TUiEffects = {
    transition?: TUiTransition;
};

export type TUiEffectsCarrier = { uiEffects?: TUiEffects };

/** An action as the backend may send it, with the optional `uiEffects` override. */
export type TUiEffectsAction = TWAction & TUiEffectsCarrier;
